import React, {Component} from "react";
import {connect} from "react-redux";
import {toastr} from 'react-redux-toastr';
import ActivitiesForm from "../../../../components/Forms/ActivitiesForm/ActivitiesForm.jsx";

import './Activities.scss'
import FreelancePage from "../../../../../shared/components/Styled/Containers/FreelancePage.jsx";

class Activities extends Component {
  expandSecteurs = (freelance) => {
    const selectedSecteursIds = freelance.secteurs.map(secteur => secteur.id);
    return this.props.secteurs.reduce((acc, secteur) => {
      secteur.checked = selectedSecteursIds.includes(secteur.id);
      acc.push(secteur);
      return acc;
    }, []);
  };

  submit = (values) => {
    const selectedSecteurs = this.prepareFreelance(values.freelance).secteurs

    if (!selectedSecteurs.length) {
      toastr.error("Veuillez renseigner minimum un secteur pour valider le formulaire.")
    } else {
      this.props.submit({
        freelance: this.prepareFreelance(values.freelance)
      });
    }
  };

  prepareFreelance = (freelance) => {
    return {
      ...freelance,
      secteurs: freelance.secteurs.reduce((acc, secteur) => {
        if (secteur.checked === true) {
          acc.push(secteur);
        }
        return acc;
      }, [])
    }
  };

  render() {
    const {freelance} = this.props
    return (
      <div>
        <FreelancePage>
          <h4 className="text-center mt-5 mb-4">Secteurs</h4>

          <p className="subtitle">Merci d’indiquer les secteurs dans lesquels vous avez travaillé pendant au moins 1 an
            (et non ceux dans lesquels vous souhaitez travailler).</p>
          <ActivitiesForm
            enableReinitialize={true}
            onSubmit={this.submit}
            onSubmitSuccess={this.props.onFormSuccess}
            initialValues={{
              freelance: {...freelance, secteurs: this.expandSecteurs(freelance)}
            }}/>
        </FreelancePage>
      </div>
    );
  }
}

export default connect(
  state => ({
    secteurs: state.secteurs.secteurs
  })
)(Activities);